import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { catchError, retry } from 'rxjs/operators';
import { ElogioVO } from 'src/app/entity/ElogioVO';
import { URL_API } from 'src/app/tools/URL';
import { ATUALIZAR, CARREGAR, ENVIAR, ErrorsService, SALVAR } from '../errors/errors.service';
import { RestService } from '../rest.service';
import { AuthService } from '../autenticacao/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ElogioService {
  elogio = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_ELOGIO}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      this.elogio.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.elogio.controls.assuntos.setValue(retorno.assuntos);
    });

  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_ELOGIO + '/' + id}`);

  }

  gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

    this.elogio.controls.nome.setValue(manifestante.nome);
    this.elogio.controls.email.setValue(manifestante.email);
    this.elogio.controls.username.setValue(this.authService.usuarioLogado.username);

    this.elogio.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.elogio.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    return isEnviar ? this.enviar(this.elogio.value) : this.salvar(this.elogio.value);

  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  public enviar(obj: ElogioVO) {
    return this.rest.post(`${URL_API.PATH_ELOGIO}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  private gravar(obj: ElogioVO) {
    return this.rest.post(`${URL_API.PATH_ELOGIO}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  private atualizar(obj) {
    return this.rest.put(`${URL_API.PATH_ELOGIO}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  preencherVo() {
    return {
      id: null,
      files: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      nome: new FormControl({ value: null }, [Validators.required]),
      email: new FormControl({ value: null }, [Validators.required]),
      assunto: new FormControl(null, [Validators.required]),
      nomeElogiado: new FormControl(null, [Validators.required]),
      descricaoElogio: new FormControl(null, [Validators.required]),
      listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      assuntos: [],

      demandaRecebida: new FormControl(null)

    } as ElogioVO;
  }

}
